/**
 * Document offset of `element` within `ancestor`, based on sibling layout heights.
 * Prefer this over getBoundingClientRect + scrollTop when sticky ancestors are present —
 * sticky shifts getBoundingClientRect without changing layout flow, which can desync
 * TanStack Virtual's scrollMargin and leave a blank gap above the virtualized rows.
 */
export const getOffsetRelativeToAncestor = (
  element: HTMLElement,
  ancestor: HTMLElement,
): number => {
  let offset = 0;
  let current: HTMLElement | null = element;

  while (current && current !== ancestor) {
    const parent: HTMLElement | null = current.parentElement;
    if (!parent) {
      break;
    }

    for (const sibling of Array.from(parent.children)) {
      if (sibling === current) {
        break;
      }
      if (sibling instanceof HTMLElement) {
        offset += sibling.offsetHeight;
      }
    }

    current = parent;
  }

  return offset;
};
